// src/context/mountPointScopes.ts
var scopes = /* @__PURE__ */ new WeakMap();
var registerMountPoint = (element, outlets) => {
  scopes.set(element, outlets);
  return () => {
    scopes.delete(element);
  };
};
var outletScopeFor = (element, fallback) => {
  let node = element;
  while (node) {
    if (node instanceof Element) {
      const scope = scopes.get(node);
      if (scope) {
        return scope;
      }
    }
    node = node instanceof ShadowRoot ? node.host : node.parentNode;
  }
  return fallback;
};
export {
  outletScopeFor,
  registerMountPoint
};
//# sourceMappingURL=mountPointScopes.js.map